"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSupplyDetails = void 0;
const Base_1 = require("./Base");
exports.GetSupplyDetails = {
    url: Base_1.URL_BASE + "/GetSupplyDetails",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetSupplyDetails.js.map